import BlogHeroSection from "./components/blog-hero-section";
import BlogCard, {BlogCardAnimation} from "./components/blog-card";
import useListApi from "../../../hooks/useListApi";
import URLS from "../../../API/Axios/URLS";
import {getUri} from "../../../utils/utils";
import {IoIosSad} from "react-icons/io";
import Paginator from "../../../components/Table/Paginator";
import LoadMoreButton from "../../../components/Buttons/LoadMore/LoadMoreButton";

export default function BlogPage({className, ...props}) {
    let [blogData, filter, isDataLoading, blogActions] = useListApi(URLS.blogsList, {
        page_size: 16,
        query: "",
    });
    return (<div className={"flex flex-col  "}>
            <BlogHeroSection
                onChange={(event) => {
                    blogActions.updateFilter({query: event.target.value})
                }}
            />
            <div className={"px-4 lg:px-[80px] flex flex-col gap-[32px] py-[30px]"}>
                <p className={"font-bold"}>
                    All blog posts
                </p>
                <div className={"grid grid-cols-1 gap-[32px] md:grid-cols-2  lg:grid-cols-3 xl:grid-cols-4"}>
                    {isDataLoading && <>
                        {
                            Array(16).fill(0).map((_, index) => (
                                <BlogCardAnimation key={index} className={"w-full"}/>
                            ))
                        }
                    </>
                    }
                    {
                        blogData?.results?.map((item, index) => {
                            return <BlogCard
                                key={index}
                                title={item?.title}
                                metaDescription={item.meta_description}
                                date={item?.updated_at}
                                thumbnail={getUri(item.thumbnail?.file)}
                            />
                        })
                    }

                </div>

                {
                    blogData?.next   ?
                        <div className={"w-full flex-col justify-center items-center flex "}>

                            <LoadMoreButton
                                onClick={() => {
                                    blogActions.loadmore()
                                }}
                                className={" "}
                            />

                        </div> : <></>
                }
                {
                    !isDataLoading && blogData?.results?.length === 0 &&
                    <div className={"flex flex-col my-12 gap-2 items-center"}>
                        <IoIosSad className={"text-4xl"}/>
                        <p className={"font-bold text-xl"}>
                            Total {blogData?.count} results found
                        </p>
                    </div>
                }

            </div>
        </div>

    )
}